<nav>
	<div class="nav nav-tabs mt-1" id="nav-tab" role="tablist">
		<div class="col text-end">
			<button class="btn btn-outline-secondary" (click)="goBack()"><fa-icon [icon]="back" size="sm" ></fa-icon></button>
		</div>
	</div>
</nav>
<app-offer-table-data *ngIf="offers" [offerConfig]="offers" [range]="range" (onActionSuccess)="fetchData()"></app-offer-table-data>
<!-- <app-offer-table-data *ngIf="offers"></app-offer-table-data> -->